import { gql } from "lib/apolloClient";
import { resolvedFieldValueFragment } from "modules/CommonFragments";

export const plannerFieldFragment = {
  plannerFieldValue: gql`
    fragment plannerFieldNodeItem on PlannerField {
      id
      uid
      value
    }
  `,
};

export const plannerMediaFieldFragment = {
  mediaFieldNodeValue: gql`
    fragment mediaFieldNodeItem on PlannerField {
      ...plannerFieldNodeItem
      resolvedMinimalTree {
        ...resolvedFieldVideoAttachmentItem
      }
    }
    ${plannerFieldFragment.plannerFieldValue}
    ${resolvedFieldValueFragment.resolvedFieldVideoAttachment}
  `,
};
